import image1 from 'images/product-cards/product-card-0.jpg';
import image2 from 'images/product-cards/product-card-3.jpg';
import image3 from 'images/product-cards/product-card-2.jpg';
import image4 from 'images/product-cards/product-card-1.jpg';

export const data = {
    organic_line: {
        preview_title: 'Organic line',
        preview_text:
            'Betino® and VeganoХ® is approved by FiBL and Organic Standard for use in organic farming without restrictions. It is a reliable solution for increasing plant resistance to osmotic and oxidative stress.',
        preview_link_text: 'View product',
        preview_image: image1,
    },
    wuxal: {
        preview_title: 'Wuxal',
        preview_text:
            'Wuxal® — is an effective suspension for foliar treatment of plants and seed treatment, as well as a set of innovative solutions that allow you to achieve high efficiency.',
        preview_link_text: 'View product',
        preview_image: image2,
    },
    fertiplant: {
        preview_title: 'Fertiplant',
        preview_text:
            'With Fertiplant® fertilizers, you can fully rely on the impeccable quality of the product and its optimal properties.',
        preview_link_text: 'View product',
        preview_image: image3,
    },
    unifer_x: {
        preview_title: 'UniferX',
        preview_text:
            'UniferX is a high quality fine crystalline fertilizer for foliar feeding. It is designed to quickly eliminate or prevent manganese deficiency in plants.',
        preview_link_text: 'View product',
        preview_image: image4,
    },
};
